import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

import Pictures from "./Pictures";
import { PictureStudentOption } from "config/constants";

const PicturesPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const clickBackButton = React.useCallback(
    (e: Event) => {
      e.preventDefault();
      navigate(-1);
    },
    [navigate],
  );

  useEffect(() => {
    document.addEventListener("back", clickBackButton);

    return () => {
      document.removeEventListener("back", clickBackButton);
    };
  }, [clickBackButton]);

  const params = new URLSearchParams(location.search);
  const startDate = params.get("startDate") || "";
  const endDate = params.get("endDate") || "";
  const classId = params.get("classId");
  const studentIdParam = params.get("studentId");
  const hashtagId = params.get("hashtagId");
  const isFavorite = params.get("isFavorite") === "true";

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex-1">
        <Pictures
          startDate={startDate}
          endDate={endDate}
          classId={classId ? Number(classId) : undefined}
          studentId={
            studentIdParam === PictureStudentOption.all
              ? PictureStudentOption.all
              : studentIdParam === PictureStudentOption.class
                ? PictureStudentOption.class
                : studentIdParam
                  ? Number(studentIdParam)
                  : undefined
          }
          hashtagId={hashtagId ? Number(hashtagId) : undefined}
          isFavorite={isFavorite}
        />
      </div>
    </section>
  );
};

export default PicturesPage;
